<template>
    <v-dialog
        :value="open"
        class="study-form"
        max-width="636px"
        content-class="study-plan__request-dialog"
        lazy
        @input="closeFormHandle"
    >
        <v-card>
            <v-card-title>
                <v-layout column>
                    <v-layout justify-end>
                        <v-btn icon @click="closeFormHandle">
                            <v-icon color="#4A4A4A">mdi-close</v-icon>
                        </v-btn>
                    </v-layout>
                    <h2
                        class="study-form_text-dark-grey study-form__title mb-3 px-5 mx-0"
                    >
                        {{ $t('Заявка на обучение') }}
                    </h2>
                </v-layout>
            </v-card-title>
            <v-card-text class="px-5">
                <h3 class="title font-weight-regular mb-2 study-form_text-dark-grey">
                    {{ `${user.name} ${user.family} ${user.patronymic}` }}
                </h3>
                <p class="subhead study-form_text-grey">{{ user.company_name }}</p>
                <v-layout>
                    <v-flex xs8>
                        <label class="study-form__label">Email</label>
                        <p class="subhead study-form_text-dark-grey">
                            {{ user.email }}
                        </p>
                    </v-flex>
                </v-layout>
                <v-divider class="mb-4" color="#DEDEDE" />
                <label class="study-form__label">
                    {{ $t('Номер телефона') }}
                </label>
                <div class="mb-4">
                    <inputBase
                        v-mask="'+7(###)-###-##-##'"
                        class="study-form__input"
                        :value="form.phone"
                        @input="inputPhoneHandle"
                    />
                    <v-messages
                        v-if="$v.form.phone.$error"
                        class="mt-1"
                        color="#E4183E"
                        :value="[
                            !$v.form.employees.required ? $t('Поле обязательно') : '',
                            !$v.form.employees.minLength ? $t('Номер телефона должен быть не меньше 11 символов') : '',
                        ]"
                    />
                </div>
                <label class="study-form__label">
                    {{ $t('Выберите интересующие вас сегменты') }}
                </label>
                <v-checkbox
                    v-model="form.courses"
                    v-for="(course, index) in courses"
                    :key="index"
                    :label="course.label"
                    :value="course.value"
                />
                <v-messages
                    v-if="$v.form.courses.$error"
                    class="mt-1"
                    color="#E4183E"
                    :value="[$t('Поле обязательно')]"
                />
                <label class="study-form__label">
                    {{ $t('Компания, в которой будет проводиться обучение') }}
                </label>
                <div class="mb-4">
                    <input-base
                        :value="form.company"
                        class="study-form__input"
                        @input="inputCompanyHandle"
                    />
                    <v-messages
                        v-if="$v.form.company.$error"
                        class="mt-1"
                        color="#E4183E"
                        :value="[$t('Поле обязательно')]"
                    />
                </div>
                <v-layout class="mb-4" column>
                    <label class="study-form__label">{{ $t('Количество сотрудников') }}</label>
                    <v-layout column>
                        <input-base
                            v-mask="'####'"
                            :value="form.employees"
                            class="study-form__input"
                            @input="inputEmployeesHandle"
                        />
                        <v-messages
                            v-if="$v.form.employees.$error"
                            class="mt-1"
                            color="#E4183E"
                            :value="[
                                !$v.form.employees.required ? $t('Поле обязательно') : '',
                                !$v.form.employees.integer ? $t('Введите целое число') : '',
                            ]"
                        />
                    </v-layout>
                </v-layout>
                <v-layout class="mb-4" align-baseline>
                    <v-layout column>
                        <label class="study-form__label">{{ $t('Дата') }}</label>
                        <v-layout align-baseline>
                            <v-layout class="mr-2" column>
                                <v-menu
                                    v-model="dateStartMenu"
                                    lazy
                                    offset-y
                                    full-width
                                    :close-on-content-click="false"
                                    transition="scale-transition"
                                >
                                    <template #activator="{ on }">
                                        <input-base
                                            v-mask="'##.##.####'"
                                            :value="form.dateStart"
                                            :can-edit="false"
                                            class="study-form__input"
                                            v-on="on"
                                        />
                                        <span class="study-form__error-field">
                                            {{ $v.form.dateStart.$error ? $t('Поле обязательно') : '' }}
                                        </span>
                                    </template>
                                    <v-date-picker
                                        v-model="formattedDateStart"
                                        class="study-form__event-date"
                                        :first-day-of-week="1"
                                        :locale="lang"
                                        :allowed-dates="isAllowedDate"
                                        no-title
                                    />
                                </v-menu>
                            </v-layout>
                        </v-layout>
                    </v-layout>
                    <v-layout class="ml-4" column>
                        <label class="study-form__label">{{ $t('Время начала') }}</label>
                        <v-menu
                            v-model="timeMenu"
                            lazy
                            offset-y
                            full-width
                            :close-on-content-click="false"
                            transition="scale-transition"
                        >
                            <template #activator="{ on }">
                                <input-base
                                    v-mask="'##:##'"
                                    :value="form.time"
                                    :can-edit="false"
                                    class="study-form__input"
                                    v-on="on"
                                />
                                <span class="study-form__error-field">
                                    {{ $v.form.time.$error ? $t('Поле обязательно') : '' }}
                                </span>
                            </template>
                            <v-time-picker
                                v-model="form.time"
                                class="study-form__event-date"
                                format="24hr"
                                :locale="lang"
                            />
                        </v-menu>
                    </v-layout>
                </v-layout>
                <v-layout column>
                    <label class="study-form__label">{{ $t('Особые пожелания') }}</label>
                    <text-area
                        :value="form.comment"
                        class="study-form__input"
                        @input="inputCommentHandle"
                    />
                </v-layout>
            </v-card-text>
            <v-card-actions class="px-5">
                <v-layout class="my-4">
                    <button-white
                        class="study-form__btn mr-5"
                        @click.native="closeFormHandle"
                    >
                        {{ $t("Отмена") }}
                    </button-white>
                    <button-red
                        class="study-form__btn"
                        @click.native="submitForm"
                    >
                        {{ $t("Сохранить") }}
                    </button-red>
                </v-layout>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import InputBase from '@inputs/base/input.vue';
import TextArea from '@inputs/base/textarea.vue';
import {validationMixin} from 'vuelidate';
import {required, integer, minLength} from 'vuelidate/lib/validators';
import ButtonWhite from '@/components/ui/buttons/button_bd_white.vue';
import ButtonRed from '@/components/ui/buttons/button_red.vue';
import dayjs from 'dayjs';

export default {
  name      : 'StudyPlanRequestForm',
  components: {ButtonRed, ButtonWhite, TextArea, InputBase},
  mixins    : [validationMixin],
  validations() {
    return {
      form: {
        dateStart: {
          required,
        },
        time: {
          required,
        },
        company: {
          required,
        },
        phone: {
          required,
          minLength: minLength(17),
        },
        employees: {
          required,
          integer,
        },
        courses: {
          required,
        },
      },
    };
  },
  props: {
    open: {
      type   : Boolean,
      default: false,
    },
    request: {
      type   : Object,
      default: () => ({
        dateStart: '',
        phone    : '',
        time     : '08:00',
        comment  : '',
        employees: '1',
        company  : '',
        courses  : [],
      }),
    },
  },
  data: () => ({
    courses      : [],
    dateStartMenu: false,
    timeMenu     : false,
    form         : {
      dateStart: '',
      phone    : '',
      time     : '08:00',
      comment  : '',
      employees: '1',
      company  : '',
      courses  : [],
    },
  }),
  computed: {
    ...mapGetters('profile/user', [
      'user',
      'user_phone',
    ]),
    ...mapGetters('study_plan', ['get_disabled_dates', 'get_events']),
    ...mapGetters('profile/general', ['lang']),
    formattedDateStart: {
      get() {
        if (this.form.dateStart) {
          return this.formatDate(this.form.dateStart).toISOString().substr(0, 10);
        }
        return new Date().toISOString().substr(0, 10);
      },
      set(value) {
        this.form.dateStart = dayjs(value).format('DD.MM.YYYY');
      },
    },
    formattedDateEnd: {
      get() {
        if (this.form.dateEnd) {
          return this.formatDate(this.form.dateEnd).toISOString().substr(0, 10);
        }
        return new Date().toISOString().substr(0, 10);
      },
      set(value) {
        this.form.dateEnd = dayjs(value).format('DD.MM.YYYY');
      },
    },
  },
  watch: {
    async open(flag) {
      if (flag) {
        const formFields = await this.fetch_request_form_fields();
        this.courses = formFields.segments;
      }
      this.form = {...this.request};
    },
  },
  methods: {
    ...mapActions('study_plan', ['fetch_request_form_fields']),
    isAllowedDate(val) {
      const formattedDate = dayjs(val).format('YYYY.MM.DD');
      return !this.get_disabled_dates.includes(formattedDate) &&
        (dayjs(val).isAfter(dayjs()) || this.form.dateStart === dayjs(val).format('DD.MM.YYYY')) &&
        !this.get_events[formattedDate];
    },
    formatDate(value) {
      const date = value.split('.');
      return dayjs()
          .set('date', +date[0])
          .set('month', +date[1] - 1)
          .set('year', +date[2]);
    },
    closeFormHandle() {
      this.$emit('close');
      this.$v.$reset();
    },
    inputCompanyHandle(e) {
      this.form.company = e.target.value;
    },
    inputCommentHandle(e) {
      this.form.comment = e.target.value;
    },
    inputEmployeesHandle(e) {
      this.form.employees = e.target.value;
    },
    inputPhoneHandle(e) {
      this.form.phone = e.target.value;
    },
    submitForm() {
      this.$v.$touch();
      if (!this.$v.$error) {
        this.form.phone = this.form.phone.replace(new RegExp(/[-()/\\]/g), '');
        this.$emit('submit', this.form);
        this.form = {...this.request};
        this.closeFormHandle();
      }
    },
  },
};
</script>

<style lang="less">
.study-plan__request-dialog {
  height: 100%;
  & .v-card {
    height: 100%;
    display: flex;
    flex-direction: column;
    & .v-card__text {
      overflow: auto;
      flex: 1;
    }
  }
}
</style>
